import "bootstrap-icons/font/bootstrap-icons.css";

import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { eligibility } from "constants/eligibility";
import { LinkButton } from "components/buttons";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import banktable2 from "assets/images/bankguarantee_table_2.svg";
import banktable from "assets/images/bankguarantee_table.svg";
import outline_check from "assets/images/outline_check.svg";

function BankGuarantee() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`Bank
              <span className="jumbotron-subtitle-2">
                Guarantee-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Features</h3>
          </div>
          <div className="col-xl-8">
            <div className="features-container flex-wrap">
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Applicable via</div>
                <div className="column-subheader">
                  Financing line or cash mode solution{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Currency</div>
                <div className="column-subheader">
                  Available in MYR & selected foreign currencies{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Honour payment</div>
                <div className="column-subheader">
                  To your beneficiary upon receipt of a claim{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column">
                <div className="column-header">Raise cash</div>
                <div className="column-subheader">
                  No necessity to raise cash to meet the deposit requirementsand
                  funds could be used tosupport working capital requirements
                  (with financingline){" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              A Bank Guarantee (BG-<i>i&nbsp;</i>) is a payment undertaking
              given by the Bank (guarantor) in writing at the request of
              customer (principal/ applicant) to pay stated sum of money to the
              beneficiary upon presentation of written demand. BG-<i>i&nbsp;</i>{" "}
              serves as a surety by alrajhi bank Malaysia who agrees to be
              responsible for the financial obligation of the applicant. It is
              issued on behalf of customer to facilitate the usage of products
              or services, or to secure contracts and issued guarantee
              instrument. The BG-<i>i&nbsp;</i> product can be offered to
              customer with/out financing facility.
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div
          className="row container align-item-center"
          style={{ justifyContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Shariah Contract</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Wakalah, Ujrah</div>
                <div className="column-subheader-2">
                  The Bank acts as an agent (wakeel) to issue a written
                  guarantee backed by upfront payment from the Customer{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Kafalah</div>
                <div className="column-subheader-2">
                  The Bank acts as a guarantor where the Bank will guarantee the
                  Customer’s project or performance{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitybank.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      style={{ fontSize: "16px" }}
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={banktable}
              className="d-inline-block align-top"
              alt=""
            />
            <p>* Notes: </p>
            <p>
              1. Commissions and rates specified herein apply to a single
              transaction. Any incidental charges such as
              remittance/postage/courier will be charged according to
              usage/destination. 
            </p>

            <p>
              2. Total fees, charges and/or commission quoted are subject to
              applicable taxes (if any). 
            </p>

            <p>
              3. The Bank reserves the right to vary such fees and charges
              and/or commission with prior notice or as agreed with the customer
              in the Letter of Offer. 
            </p>
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
                paddingTop: "40px",
              }}
              src={banktable2}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <LinkButton
                text={
                  <span>
                    BG-<em>i</em> Application Form - Wakalah
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/1646102684_BG-i_Wakalah_Application_Form.pdf "
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet (Wakalah)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/1680578205_PDS_BG-i_Wakalah.pdf "
                  )
                }
              />
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/1680579344_Trade Finance Instruments - Fees and Charges.pdf"
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet (Kafalah)"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/PDS_BG-i_Kafalah.pdf "
                  )
                }
              />
              <LinkButton
                text={
                  <span>
                    BG-<em>i</em> Application Form - Cash Margin Kafalah
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/Bank Guarantee-i (Kafalah) Application Form.pdf "
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default BankGuarantee;
